import React, { Component } from "react";
import "./CheckBox.css";
import "../Styles/SvgCommand.css";

const CheckBox = (props) => {
  return (
    <svg
      style={{
        maxWidth: props.width ? props.width : "13px",
        minWidth: props.width ? props.width : "13px",
        maxHeight: props.width ? props.width : "13px",
        minHeight: props.width ? props.width : "13px",
      }}
      className={
        props.isLeastOneAndNotAllChildsChecked
          ? "middleChecked"
          : props.checked
          ? "checked"
          : "unChecked"
      }
      onClick={props.click}
    >
      <rect
        style={{
          visibility: props.isLeastOneAndNotAllChildsChecked
            ? "collapse"
            : "visible",
        }}
        x="6"
        y="2"
        width="4.5"
        height="1.5"
        transform="rotate(45)"
        rx="0"
      />
      <rect
        style={{
          visibility: props.isLeastOneAndNotAllChildsChecked
            ? "collapse"
            : "visible",
        }}
        x="-4"
        y="9"
        width="8"
        height="1.5"
        transform="rotate(-50)"
        rx="0"
      />

      <line
        x1="2"
        y1="6.5"
        x2="11"
        y2="6.5"
        style={{
          visibility: props.isLeastOneAndNotAllChildsChecked
            ? "visible"
            : "collapse",
        }}
      />
    </svg>
  );
};

export default CheckBox;
